export default "__VITE_ASSET__YoLl8x2O__"